import * as React from 'react';

import AllCollectionsPageContent from 'bundles/enterprise-collections/pages/AllCollectionsPageContent';
import EnterprisePageTemplateWrapper from 'bundles/unified-common/pageUtils/EnterprisePageTemplateWrapper';
import EnterprisePageDataProvider from 'bundles/unified-common/providers/EnterprisePageDataProvider';
import EnterprisePageTrackingWrapper from 'bundles/unified-home-common/pages/enterprise/EnterprisePageTrackingWrapper';

const AllCollectionsPageRoot = () => {
  return (
    <EnterprisePageDataProvider>
      <EnterprisePageTemplateWrapper>
        <EnterprisePageTrackingWrapper>
          <AllCollectionsPageContent />
        </EnterprisePageTrackingWrapper>
      </EnterprisePageTemplateWrapper>
    </EnterprisePageDataProvider>
  );
};

export default AllCollectionsPageRoot;
